
    import './styles.scoped.css';
    export default {
  "root": "_root_1794k_3",
  "label": "_label_1794k_7",
  "stud": "_stud_1794k_22"
};
  